/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Emailtemplate2Inputs */

const en_coinvestments_nav_emailtemplate2 = /** @type {(inputs: Coinvestments_Nav_Emailtemplate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email template`)
};

/**
* | output |
* | --- |
* | "Email template" |
*
* @param {Coinvestments_Nav_Emailtemplate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_emailtemplate2 = /** @type {((inputs?: Coinvestments_Nav_Emailtemplate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Emailtemplate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_emailtemplate2(inputs)
});
export { coinvestments_nav_emailtemplate2 as "coInvestments_nav_emailTemplate" }